import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientSearchProvider } from '@brightai/ui';
import { BrightAiOmniSearchRegistry } from '@brighthub/brightai-registry';
import { ConversationSearchProvider } from '@brighthub/brightai-conversation-search';
import { EmployeeSearchProvider } from '@brighthub/brightai-employee-search';

import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'bai-brightai-shell',
  imports: [
    CommonModule,
    RouterOutlet,
  ],
  templateUrl: './brightai-shell.component.html',
  styleUrl: './brightai-shell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    ClientSearchProvider,
    ConversationSearchProvider,
    EmployeeSearchProvider,
  ],
})
export class BrightaiShellComponent {
  brightAiOmniSearchRegistry = inject(BrightAiOmniSearchRegistry);

  constructor() {
    this.brightAiOmniSearchRegistry.registerProviders();
  }
}
